"use client";

import { useMemo } from "react";
import { usePathname } from "next/navigation";

import { buildBreadcrumbs, type BuildBreadcrumbsOptions } from "@/lib/routes";
import type { IBreadcrumbItem } from "@/types/breadcrumb";

// ----------------------------------------------------------------------
// Breadcrumb trail for the current route, derived from the pathname.
// Returns an empty array on pages where breadcrumbs don't apply (home page,
// full-screen routes) — see `buildBreadcrumbs`.
// ----------------------------------------------------------------------

export default function useBreadcrumbs({
  labels,
  currentLabel,
}: BuildBreadcrumbsOptions = {}): IBreadcrumbItem[] {
  const pathname = usePathname();

  return useMemo(
    () => buildBreadcrumbs(pathname, { labels, currentLabel }),
    [pathname, labels, currentLabel],
  );
}
